var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14515",
    "data-name": "Group 14515",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.006,
    height: 147.405,
    viewBox: "0 0 142.006 147.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.16,
    y1: 1.19,
    x2: -0.158,
    y2: 1.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00399d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc0f0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffaf0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17651",
    "data-name": "Rectangle 17651",
    width: 60.478,
    height: 81.415,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27347",
    "data-name": "Path 27347",
    d: "M.03,27.5h0A1.053,1.053,0,0,0,.8,28.769l17.947,4.366a1.053,1.053,0,0,0,1.272-.774h0a1.053,1.053,0,0,0-.774-1.272L1.3,26.723A1.051,1.051,0,0,0,.03,27.5m1.3-5.339A1.053,1.053,0,0,0,2.1,23.43l23.876,5.809a1.053,1.053,0,0,0,1.272-.774h0a1.053,1.053,0,0,0-.774-1.272L2.6,21.384a1.052,1.052,0,0,0-1.272.774m1.3-5.339h0A1.053,1.053,0,0,0,3.4,18.092L27.278,23.9a1.053,1.053,0,0,0,.5-2.046L3.9,16.046a1.052,1.052,0,0,0-1.272.774m1.3-5.339A1.053,1.053,0,0,0,4.7,12.753l23.876,5.809a1.053,1.053,0,0,0,.5-2.046L5.2,10.707a1.052,1.052,0,0,0-1.272.774m1.3-5.339h0A1.053,1.053,0,0,0,6,7.415l23.876,5.809a1.053,1.053,0,0,0,1.272-.774h0a1.053,1.053,0,0,0-.774-1.272L6.5,5.369a1.051,1.051,0,0,0-1.272.774M6.524.8A1.053,1.053,0,0,0,7.3,2.076L31.174,7.885a1.053,1.053,0,0,0,.5-2.046L7.8.03A1.052,1.052,0,0,0,6.524.8",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13956",
    "data-name": "Group 13956",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27324",
    "data-name": "Path 27324",
    d: "M142.006,71a71,71,0,0,1-71,71,71.826,71.826,0,0,1-8.329-.483q-1.295-.15-2.573-.349a70.928,70.928,0,0,1-44.636-25.936q-.56-.7-1.1-1.416A71.007,71.007,0,0,1,64.422.3C64.713.275,65,.248,65.3.227c.248-.021.495-.039.743-.055.072-.005.144-.011.217-.014.5-.035.993-.063,1.493-.085Q69.366,0,71,0a70.819,70.819,0,0,1,52.7,23.423q.819.906,1.608,1.842c.041.048.079.093.118.141q.312.37.616.745a70.986,70.986,0,0,1,6.663,9.706q.468.819.914,1.654A70.676,70.676,0,0,1,142.006,71",
    transform: "translate(0 5.398)",
    fill: "#71324d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27326",
    "data-name": "Path 27326",
    d: "M93.745,20.042c-.493,2-.905,4.016-1.25,6.05q-.346,2.026-.606,4.072c-.016.12-.03.239-.046.359a161.332,161.332,0,0,0-1.078,16.232c-.005.229-.011.456-.016.683-.005.25-.011.5-.014.752-.053,2.92-.053,5.84-.026,8.762q.024,2.486.067,4.972c.005.343.012.687.018,1.029.086,4.984.2,9.969.192,14.953q0,1.664-.019,3.33-.021,1.781-.069,3.561c-.007.294-.016.586-.025.881-.053,1.735-.139,3.47-.225,5.2-.12,2.387-.245,4.773-.3,7.163-.007.291-.011.583-.016.875-.683.712-1.381,1.395-2.084,2.05-6.577,6.138-13.759,9.893-16.88,12.073q-.571.4-1.117.777-1.247.864-2.378,1.633c-.315.213-.623.423-.925.625-9.617,6.487-13.4,8.216-21.211,13.969A70.952,70.952,0,0,1,0,102.7a37.958,37.958,0,0,0,4.7-8.542C7.7,86,8.255,76.882,10.045,67.269c4.44-23.833,4.893-43.3,9.773-47.982,1.678-1.606,5.874-2.268,9.974-7.4v0h0c.09-.113.18-.229.269-.345.27-.352.541-.726.808-1.12,3.066-4.5,3.855-7.786,5.456-9.349.032-.032.062-.06.093-.09a3.715,3.715,0,0,1,.292-.241c.033-.025.067-.049.1-.072a3.178,3.178,0,0,1,.668-.354c.04-.016.081-.032.122-.046a4.933,4.933,0,0,1,.569-.157c.129-.026.257-.049.388-.065s.261-.03.393-.035c.067,0,.132-.007.2-.007,4.9-.069,5.581,5.647,4.681,11.306-.019.127-.041.254-.062.38a38.552,38.552,0,0,1-1.606,6.256A104.9,104.9,0,0,1,36.1,31.052c-.111.215-.22.435-.326.659a4.957,4.957,0,0,0-.4,1.458c-.382,2.675.326,7.01.255,12.065a9.124,9.124,0,0,0,.3,2.783,2.724,2.724,0,0,0,.532,1.013,1.393,1.393,0,0,0,.153.153,1.992,1.992,0,0,0,1.939.285c2.175-.583,5.361-3.262,8.854-6.18a68.734,68.734,0,0,1,9-6.738c-2.022-3.524-3.574-6.478-3.11-9.4a6.835,6.835,0,0,1,.588-1.876c3.767-7.933,20.984-11.506,35.495-6.908a38.1,38.1,0,0,1,4.366,1.678",
    transform: "translate(14.363 16.525)",
    fill: "#fca77f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27327",
    "data-name": "Path 27327",
    d: "M0,0A28.474,28.474,0,0,0,4.447,3.838,15.846,15.846,0,0,0,11.743,6a37.131,37.131,0,0,1-6.36-2.649C2.55,1.8,0,0,0,0",
    transform: "translate(48.739 129.576)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27328",
    "data-name": "Path 27328",
    d: "M0,0A43.471,43.471,0,0,0,4.095,9.235c3.8,5.83,10.777,9.443,10.777,9.443A70.48,70.48,0,0,1,6.224,9.4,110.881,110.881,0,0,1,0,0",
    transform: "translate(30.028 106.892)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27329",
    "data-name": "Path 27329",
    d: "M20.248,10.122c-1.239-.569-2.464-1.14-3.653-1.7C6.8,3.785.254.131,0,0A82.64,82.64,0,0,0,11.686,6.98c2.6,1.289,5.547,2.622,8.529,3.91q.017-.384.034-.768",
    transform: "translate(84.924 93.831)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27330",
    "data-name": "Path 27330",
    d: "M0,11.882c5.05,0,9.246-2.228,10.316-5.933A7.52,7.52,0,0,0,9.361,0,4.9,4.9,0,0,0,7.813.266C5.178,1.18,4.855,4.874,1.08,10.416Q.543,11.2,0,11.882",
    transform: "translate(44.155 16.526)",
    fill: "#f7d0ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27331",
    "data-name": "Path 27331",
    d: "M.029.133A61.278,61.278,0,0,0,7.486,6.3a4.939,4.939,0,0,1,.4-1.46c.107-.223.216-.443.326-.659C6.2,3.235,3.871,2.134,3.653,2.01l-3.5-2C.058-.037-.053.06.029.133",
    transform: "translate(42.252 43.394)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27332",
    "data-name": "Path 27332",
    d: "M17.856,17.355c3.918-1.417,16.647-4.113,14.3-12.741C31.18,1.014,28.642.265,24.344.05,19.112-.212,4.27.395.721,5.7c-2.816,4.21,3.317,9.95,6.29,12.606,2.365,2.113,6.215.721,10.844-.953",
    transform: "translate(101.639 30.64)",
    fill: "#fca77f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27333",
    "data-name": "Path 27333",
    d: "M21.877,6.037,0,0,.243,23.531,19,14.657Z",
    transform: "translate(103.682 41.74)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27334",
    "data-name": "Path 27334",
    d: "M26.187,16.841,13.016,0,0,17.945l19.172,3.8Z",
    transform: "translate(95.032 74.44)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27335",
    "data-name": "Path 27335",
    d: "M26.3,13.121,7.779,0,0,22.21l20.655-1.962Z",
    transform: "translate(99.258 57.829)",
    fill: "#f18e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27337",
    "data-name": "Path 27337",
    d: "M62.975,120.315l.2-.823q.353-1.469.71-2.937l3.422-14.145.9-3.712,1.158-4.789.056-.227,1.112-4.6,1.572-6.5.652-2.693.259-1.066.376-1.554.055-.225,1.748-7.229,1.275-5.272.137-.563.838-3.462.8-3.313.348-1.436,1.552-6.412.671-2.776.153-.633,3.771-15.589.032-.135,1.667-6.889c.034-.143.069-.287.106-.43l0-.016a13.269,13.269,0,0,0,.5-3.042,9,9,0,0,0-4.541-8.029,9.907,9.907,0,0,0-2.35-.861L79.9,10.89,36.837.472,36.5.389c-.234-.058-.467-.115-.7-.17a8.757,8.757,0,0,0-8.45,2.7A8.392,8.392,0,0,0,25.8,5.411,22.89,22.89,0,0,0,24.791,8.7L11.365,64.189l-11.2,46.3a9.448,9.448,0,0,0,.343,4.741c.008.027.017.053.026.08.022.066.044.131.067.2.039.111.08.22.124.329a8.458,8.458,0,0,0,3.986,4.426,11.087,11.087,0,0,0,2.419.867c.46.116.923.216,1.334.3.372.081.706.153,1.028.233l32.463,7.853,9.315,2.252a8.364,8.364,0,0,0,4.25-.119,9.283,9.283,0,0,0,6.344-6.753l.051-.208q.066-.277.135-.555c.061-.245.121-.49.18-.73q.373-1.545.746-3.091m-2.962,3.314c-.062.25-.122.5-.182.747l0,.015a7.173,7.173,0,0,1-4.89,5.244,6.282,6.282,0,0,1-3.2.09l-7.441-1.8-34.309-8.3c-.355-.086-.722-.165-1.078-.243-.418-.09-.85-.184-1.265-.288a8.987,8.987,0,0,1-1.965-.694,6.407,6.407,0,0,1-3.007-3.347,7.592,7.592,0,0,1-.467-4.068L13.418,64.628,26.829,9.2A14.194,14.194,0,0,1,28.207,5.27a6.124,6.124,0,0,1,.7-.94,6.656,6.656,0,0,1,6.419-2.068c.225.053.449.109.675.163l.353.086L79.407,12.929c.081.019.161.038.242.06a7.692,7.692,0,0,1,1.855.668,6.884,6.884,0,0,1,3.45,6.149,11.668,11.668,0,0,1-.445,2.583c-.036.15-.074.3-.11.45L83.051,28.4l-.432,1.788L78.944,45.378l-.476,1.967-1.486,6.142L75.962,57.7l-.154.639-.014.06-1.023,4.22-.009.04-3,12.416-.578,2.389-.073.3-.546,2.263L67.649,92.066l-.29,1.2-.743,3.069-.044.184-1.086,4.488L64.4,105.482l-2.395,9.9-.165.684q-.356,1.469-.709,2.939-.472,1.957-.947,3.911c-.057.241-.117.479-.176.718",
    transform: "translate(39.579 0)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27338",
    "data-name": "Path 27338",
    d: "M57.917,121.531c-.062.25-.121.5-.182.747l0,.015a7.173,7.173,0,0,1-4.89,5.244,6.283,6.283,0,0,1-3.2.09l-7.441-1.8-34.309-8.3c-.355-.086-.722-.165-1.078-.243-.418-.09-.85-.184-1.265-.288a8.985,8.985,0,0,1-1.965-.694,6.408,6.408,0,0,1-3.008-3.347,7.593,7.593,0,0,1-.467-4.068L11.323,62.53,24.734,7.1a14.185,14.185,0,0,1,1.378-3.925,6.124,6.124,0,0,1,.7-.94A6.656,6.656,0,0,1,33.226.165c.225.053.449.109.675.163l.353.086L77.311,10.831c.081.019.161.038.242.06a7.688,7.688,0,0,1,1.855.668,6.884,6.884,0,0,1,3.45,6.149,11.661,11.661,0,0,1-.445,2.583c-.036.15-.074.3-.11.45L80.956,26.3l-.432,1.788L76.848,43.28l-.476,1.967L74.886,51.39l-1.019,4.216-.154.639L73.7,56.3l-1.023,4.22-.009.04-3,12.416-.578,2.389-.073.3-.546,2.263L65.554,89.968l-.29,1.2-.743,3.069-.044.184L63.392,98.91l-1.082,4.474-2.394,9.9-.166.684q-.356,1.469-.709,2.939-.472,1.957-.947,3.911c-.057.241-.117.478-.176.718",
    transform: "translate(41.673 2.098)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27339",
    "data-name": "Path 27339",
    d: "M15.754,8.847A12.381,12.381,0,0,1,11.1,16.895c-1.746,1.431-4.142,2.9-6.5,2.4a6.219,6.219,0,0,1-3.474-2.462,4.878,4.878,0,0,1-1.093-2.3c-.263-2.1,1.364-4.785,2.337-6.546a25.018,25.018,0,0,1,4.868-6.3A5.77,5.77,0,0,1,10.028.047,4.492,4.492,0,0,1,14.357,2.37a10.813,10.813,0,0,1,1.4,6.477",
    transform: "translate(114.67 47.422)",
    fill: "#fca77f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27340",
    "data-name": "Path 27340",
    d: "M4.4,8.61.007,3.029C-.167,2.808,3.12.512,3.36.4A3.288,3.288,0,0,1,5.751.118,3.365,3.365,0,0,1,7.5,1.594C9.473,4.721,7.11,7.2,4.4,8.61",
    transform: "translate(116.216 56.119)",
    fill: "#f7d0ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27341",
    "data-name": "Path 27341",
    d: "M16.48,9.685c-1.141,2.907-4.088,4.878-6.973,6.526-1.977,1.13-4.555,2.2-6.576,1.415A4.819,4.819,0,0,1,.42,14.811a4.354,4.354,0,0,1-.381-2.345c.323-2.041,2.525-4.38,3.884-5.928a29.415,29.415,0,0,1,6.127-5.351A6.2,6.2,0,0,1,13.039,0c1.644-.053,3.465,1.782,3.9,3.318a10.637,10.637,0,0,1-.458,6.365",
    transform: "translate(104.873 86.589)",
    fill: "#fca77f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27342",
    "data-name": "Path 27342",
    d: "M3.505,7.761.005,3.128C-.134,2.945,2.653.62,2.855.5A2.706,2.706,0,0,1,4.845.051,2.381,2.381,0,0,1,6.26,1.228c1.557,2.636-.467,5.05-2.754,6.533",
    transform: "translate(107.155 95.11)",
    fill: "#f7d0ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27343",
    "data-name": "Path 27343",
    d: "M16.957,9.48a11.153,11.153,0,0,1-4.76,7.988c-1.847,1.358-4.4,2.709-6.987,2.039a7.745,7.745,0,0,1-3.878-2.773,5.531,5.531,0,0,1-1.28-2.451c-.368-2.187,1.3-4.844,2.292-6.595A22.49,22.49,0,0,1,7.4,1.52a5.641,5.641,0,0,1,2.98-1.5,5.545,5.545,0,0,1,4.8,2.686A11.386,11.386,0,0,1,16.957,9.48",
    transform: "translate(111.068 66.89)",
    fill: "#fca77f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27344",
    "data-name": "Path 27344",
    d: "M5.862,8.8.012,3.567C-.22,3.36,2.909.712,3.147.57A3.67,3.67,0,0,1,5.691.056,4.165,4.165,0,0,1,7.879,1.382c2.748,2.978.659,5.724-2.017,7.415",
    transform: "translate(113.017 76.074)",
    fill: "#f7d0ad"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13957",
    "data-name": "Group 13957",
    transform: "translate(51.22 21.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13780",
    "data-name": "Group 13780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13779",
    "data-name": "Group 13779",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27346",
    "data-name": "Path 27346",
    d: "M40.31,6.828,12.732.119A4.159,4.159,0,0,0,7.708,3.177L.119,34.368a4.159,4.159,0,0,0,3.058,5.024L30.755,46.1a4.159,4.159,0,0,0,5.024-3.058l7.589-31.191A4.159,4.159,0,0,0,40.31,6.828",
    transform: "translate(8.496 27.479)",
    fill: "#fff",
    stroke: "#ffaf36",
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13782",
    "data-name": "Group 13782",
    transform: "translate(14.001 33.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13781",
    "data-name": "Group 13781",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17652",
    "data-name": "Rectangle 17652",
    width: 45.816,
    height: 45.654,
    transform: "translate(-15.46 23.044) rotate(-56.326)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13784",
    "data-name": "Group 13784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13783",
    "data-name": "Group 13783",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27348",
    "data-name": "Path 27348",
    d: "M1.849,2.212.019,9.734a.645.645,0,0,0,.962.7.641.641,0,0,0,.291-.4L3.1,2.517A1.607,1.607,0,0,1,5.043,1.335l7.522,1.83a.645.645,0,1,0,.3-1.253L5.347.082a2.894,2.894,0,0,0-3.5,2.129",
    transform: "translate(9.239 19.763)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27349",
    "data-name": "Path 27349",
    d: "M8.328,13.268a.641.641,0,0,0,.291-.4l1.83-7.522a2.9,2.9,0,0,0-2.129-3.5L.8.019A.645.645,0,0,0,.019.493a.645.645,0,0,0,.474.779L8.015,3.1A1.608,1.608,0,0,1,9.2,5.042l-1.83,7.522a.645.645,0,0,0,.474.779h0a.639.639,0,0,0,.488-.076",
    transform: "translate(49.946 28.624)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27350",
    "data-name": "Path 27350",
    d: "M12.382.094a.641.641,0,0,0-.291.4L10.26,8.015A1.607,1.607,0,0,1,8.32,9.2L.8,7.366a.645.645,0,1,0-.3,1.253l7.522,1.83a2.9,2.9,0,0,0,3.5-2.129L13.343.8a.645.645,0,0,0-.962-.7",
    transform: "translate(37.878 70.883)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27351",
    "data-name": "Path 27351",
    d: "M2.692.019A.654.654,0,0,0,2.538,0a.645.645,0,0,0-.625.493L.083,8.015a2.9,2.9,0,0,0,2.129,3.5l7.522,1.83a.645.645,0,1,0,.3-1.253L2.517,10.26A1.607,1.607,0,0,1,1.336,8.32L3.166.8A.645.645,0,0,0,2.692.019",
    transform: "translate(0 59.192)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27352",
    "data-name": "Path 27352",
    d: "M11.526,2.628.8.018a.645.645,0,1,0-.3,1.253l10.728,2.61a.645.645,0,1,0,.3-1.253",
    transform: "translate(6.715 45.62)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27353",
    "data-name": "Path 27353",
    d: "M8,1.772.8.018a.645.645,0,0,0-.7.962.64.64,0,0,0,.4.291L7.7,3.025A.645.645,0,1,0,8,1.772",
    transform: "translate(44.696 54.86)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27354",
    "data-name": "Path 27354",
    d: "M9.86,2.223.8.018a.645.645,0,0,0-.7.962.641.641,0,0,0,.4.291l9.062,2.2a.645.645,0,0,0,.3-1.253",
    transform: "translate(22.895 49.556)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27355",
    "data-name": "Path 27355",
    d: "M3.85.761.8.019A.645.645,0,0,0,.492,1.272l3.053.743A.645.645,0,1,0,3.85.761",
    transform: "translate(37.129 53.019)",
    fill: "#000007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27356",
    "data-name": "Path 27356",
    d: "M.892,7.128a2.27,2.27,0,0,1-.759-.971,1.939,1.939,0,0,1-.069-1.2l1.3.317a1.209,1.209,0,0,0,.187.882,1.382,1.382,0,0,0,.87.539,1.5,1.5,0,0,0,1.056-.065,1.017,1.017,0,0,0,.543-.7.883.883,0,0,0-.071-.662,1.509,1.509,0,0,0-.456-.5,8.484,8.484,0,0,0-.835-.5A8.665,8.665,0,0,1,1.576,3.6a2.005,2.005,0,0,1-.625-.8A1.826,1.826,0,0,1,.9,1.606,2.03,2.03,0,0,1,1.494.563,2.1,2.1,0,0,1,2.57.045a3.356,3.356,0,0,1,1.4.068A2.864,2.864,0,0,1,5.6,1.082a2.047,2.047,0,0,1,.4,1.664L4.661,2.419a1,1,0,0,0-.215-.787,1.462,1.462,0,0,0-.859-.514,1.356,1.356,0,0,0-.919.059.957.957,0,0,0-.518.688.8.8,0,0,0,.072.611,1.509,1.509,0,0,0,.444.476,8.429,8.429,0,0,0,.808.491,9.427,9.427,0,0,1,1.1.7,2.059,2.059,0,0,1,.638.817,1.848,1.848,0,0,1,.052,1.206,2.085,2.085,0,0,1-.564.994,2.257,2.257,0,0,1-1.082.59,3.007,3.007,0,0,1-1.446-.03A3.418,3.418,0,0,1,.892,7.128",
    transform: "translate(27.692 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27357",
    "data-name": "Path 27357",
    d: "M.872.924A2.7,2.7,0,0,1,2.15.11,3.035,3.035,0,0,1,3.736.1a3.019,3.019,0,0,1,1.644.937,2.571,2.571,0,0,1,.593,1.676L4.659,2.394a1.429,1.429,0,0,0-.346-.808,1.558,1.558,0,0,0-.826-.461,1.516,1.516,0,0,0-1.319.239,2.3,2.3,0,0,0-.8,1.371,2.323,2.323,0,0,0,.082,1.592,1.51,1.51,0,0,0,1.061.823,1.39,1.39,0,0,0,1.625-.589l1.313.319A2.705,2.705,0,0,1,4.137,6.072a2.919,2.919,0,0,1-1.879.1,3,3,0,0,1-1.4-.743A2.731,2.731,0,0,1,.1,4.117a3.431,3.431,0,0,1,.02-1.686A3.431,3.431,0,0,1,.872.924",
    transform: "translate(34.082 3.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27358",
    "data-name": "Path 27358",
    d: "M.863.941A2.762,2.762,0,0,1,3.621.085,2.643,2.643,0,0,1,4.766.652a2.534,2.534,0,0,1,.663.879L5.636.677l1.228.3L5.433,6.858l-1.228-.3.213-.875a2.489,2.489,0,0,1-1.012.489,2.676,2.676,0,0,1-1.285-.018A2.661,2.661,0,0,1,.828,5.427,2.843,2.843,0,0,1,.095,4.1,3.447,3.447,0,0,1,.112,2.42,3.351,3.351,0,0,1,.863.941M4.928,2.5a1.814,1.814,0,0,0-.49-.843A1.769,1.769,0,0,0,3.62,1.2a1.8,1.8,0,0,0-.931.017,1.781,1.781,0,0,0-.82.513,2.16,2.16,0,0,0-.507.991,2.255,2.255,0,0,0-.009,1.129,1.821,1.821,0,0,0,.492.86,1.748,1.748,0,0,0,.812.452,1.768,1.768,0,0,0,.933-.022,1.8,1.8,0,0,0,.824-.529,2.224,2.224,0,0,0,.509-1A2.193,2.193,0,0,0,4.928,2.5",
    transform: "translate(40.496 4.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27359",
    "data-name": "Path 27359",
    d: "M5.6,1.217A2.112,2.112,0,0,1,6.248,2.28a2.893,2.893,0,0,1-.023,1.442l-.844,3.47L4.174,6.9l.8-3.288a1.758,1.758,0,0,0-.1-1.308A1.447,1.447,0,0,0,3.9,1.618a1.465,1.465,0,0,0-1.186.158,1.743,1.743,0,0,0-.7,1.114l-.8,3.288L0,5.883,1.431,0,2.648.3,2.485.969a2.073,2.073,0,0,1,.9-.38A2.514,2.514,0,0,1,4.423.626,2.716,2.716,0,0,1,5.6,1.217",
    transform: "translate(47.531 6.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27360",
    "data-name": "Path 27360",
    d: "M3.7.924a2,2,0,0,1,.633.978,2.407,2.407,0,0,1,0,1.253,2.353,2.353,0,0,1-.575,1.1,1.972,1.972,0,0,1-1.008.562,2.833,2.833,0,0,1-1.3-.037L0,4.43,1.078,0,2.524.352A2.776,2.776,0,0,1,3.7.924M2.885,4.058a1.665,1.665,0,0,0,.7-1.085,1.721,1.721,0,0,0-.121-1.305A1.617,1.617,0,0,0,2.38.945L1.66.769.871,4.014l.72.175a1.646,1.646,0,0,0,1.294-.131",
    transform: "translate(20.401 7.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27361",
    "data-name": "Path 27361",
    d: "M.54,3.235a1.673,1.673,0,0,1-.476-.791,1.978,1.978,0,0,1,0-1.009A1.94,1.94,0,0,1,.533.543a1.675,1.675,0,0,1,.8-.481,1.923,1.923,0,0,1,.966,0,1.923,1.923,0,0,1,.857.445,1.677,1.677,0,0,1,.489.794,1.941,1.941,0,0,1,0,1.007,1.9,1.9,0,0,1-.473.891,1.726,1.726,0,0,1-.816.48,1.955,1.955,0,0,1-.976,0A1.851,1.851,0,0,1,.54,3.235M2.1,3.043a1.05,1.05,0,0,0,.5-.3A1.327,1.327,0,0,0,2.9,2.125a1.356,1.356,0,0,0,.011-.683A1.02,1.02,0,0,0,2.622.95a1.094,1.094,0,0,0-.49-.261A1.076,1.076,0,0,0,1.58.7.983.983,0,0,0,1.1,1a1.405,1.405,0,0,0-.3.613,1.267,1.267,0,0,0,.077.947.986.986,0,0,0,.654.487A1.113,1.113,0,0,0,2.1,3.043",
    transform: "translate(25.045 10.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27362",
    "data-name": "Path 27362",
    d: "M.521.552A1.609,1.609,0,0,1,1.284.066,1.813,1.813,0,0,1,2.23.06a1.8,1.8,0,0,1,.981.559,1.535,1.535,0,0,1,.354,1l-.784-.191A.854.854,0,0,0,2.575.947.93.93,0,0,0,2.081.672a.905.905,0,0,0-.787.143,1.374,1.374,0,0,0-.479.818,1.387,1.387,0,0,0,.049.95.9.9,0,0,0,.633.492.83.83,0,0,0,.97-.351l.784.191a1.616,1.616,0,0,1-.781.711,1.743,1.743,0,0,1-1.122.061,1.791,1.791,0,0,1-.837-.443,1.632,1.632,0,0,1-.454-.785A2.048,2.048,0,0,1,.069,1.451a2.049,2.049,0,0,1,.452-.9",
    transform: "translate(29.103 10.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27363",
    "data-name": "Path 27363",
    d: "M3.776.782,2.921,4.293l-.727-.177L2.3,3.7a1.212,1.212,0,0,1-.532.232,1.467,1.467,0,0,1-.62-.019,1.619,1.619,0,0,1-.7-.353A1.278,1.278,0,0,1,.05,2.927a1.7,1.7,0,0,1,.01-.862L.563,0l.72.175L.807,2.132a1.049,1.049,0,0,0,.06.781.864.864,0,0,0,.582.408.875.875,0,0,0,.708-.094,1.04,1.04,0,0,0,.415-.665L3.049.6Z",
    transform: "translate(33.069 11.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27364",
    "data-name": "Path 27364",
    d: "M5.82,1.33a1.28,1.28,0,0,1,.392.636,1.7,1.7,0,0,1-.011.862L5.7,4.9l-.72-.175L5.455,2.76a1.049,1.049,0,0,0-.06-.781.864.864,0,0,0-.582-.408.875.875,0,0,0-.708.094,1.041,1.041,0,0,0-.415.665L3.212,4.293l-.72-.175L2.97,2.155a1.049,1.049,0,0,0-.06-.781A.864.864,0,0,0,2.327.966a.875.875,0,0,0-.708.094,1.04,1.04,0,0,0-.415.665L.727,3.689,0,3.512.854,0l.727.177-.1.4A1.243,1.243,0,0,1,2.018.351a1.478,1.478,0,0,1,.616.022,1.607,1.607,0,0,1,.709.361,1.256,1.256,0,0,1,.384.64,1.212,1.212,0,0,1,.62-.386A1.513,1.513,0,0,1,5.119.977a1.621,1.621,0,0,1,.7.353",
    transform: "translate(36.946 12.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27365",
    "data-name": "Path 27365",
    d: "M3.436,2.556.753,1.9A1,1,0,0,0,.9,2.655a1.014,1.014,0,0,0,.626.422.875.875,0,0,0,.948-.289l.784.191a1.629,1.629,0,0,1-.77.653,1.742,1.742,0,0,1-1.111.057,1.845,1.845,0,0,1-.847-.446,1.654,1.654,0,0,1-.47-.789A2,2,0,0,1,.067,1.446a2.049,2.049,0,0,1,.452-.9A1.591,1.591,0,0,1,1.292.063a1.893,1.893,0,0,1,.969,0,1.842,1.842,0,0,1,.833.432,1.578,1.578,0,0,1,.457.756,1.887,1.887,0,0,1,0,.954,2.339,2.339,0,0,1-.112.351m-.59-.765a.851.851,0,0,0-.13-.713A1.055,1.055,0,0,0,2.08.667a.96.96,0,0,0-.7.082A1.028,1.028,0,0,0,.9,1.319Z",
    transform: "translate(43.687 14.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27366",
    "data-name": "Path 27366",
    d: "M3.341.726a1.26,1.26,0,0,1,.389.635,1.726,1.726,0,0,1-.014.861l-.5,2.071-.72-.175L2.97,2.155a1.049,1.049,0,0,0-.06-.781A.864.864,0,0,0,2.327.966a.875.875,0,0,0-.708.094,1.041,1.041,0,0,0-.415.665L.727,3.689,0,3.512.854,0l.727.177-.1.4A1.238,1.238,0,0,1,2.021.351,1.5,1.5,0,0,1,2.64.374a1.621,1.621,0,0,1,.7.353",
    transform: "translate(47.501 15.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27367",
    "data-name": "Path 27367",
    d: "M1.254,1.644.781,3.588A.384.384,0,0,0,.8,3.894a.473.473,0,0,0,.295.163l.446.108L1.4,4.771l-.574-.14a1.138,1.138,0,0,1-.7-.412.973.973,0,0,1-.08-.809L.521,1.466l-.414-.1L.25.772l.414.1L.877,0,1.61.178,1.4,1.051l.854.208-.144.593Z",
    transform: "translate(51.941 15.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27368",
    "data-name": "Path 27368",
    d: "M.506,3.371a1.341,1.341,0,0,1-.42-.534A1.046,1.046,0,0,1,.022,2.21l.752.183A.527.527,0,0,0,.9,2.818a.8.8,0,0,0,.451.268.846.846,0,0,0,.5,0,.366.366,0,0,0,.242-.262.32.32,0,0,0-.117-.339,3.632,3.632,0,0,0-.545-.355A5.929,5.929,0,0,1,.84,1.761a1.162,1.162,0,0,1-.354-.417.843.843,0,0,1-.047-.6A.889.889,0,0,1,.729.273,1.134,1.134,0,0,1,1.293.022a1.825,1.825,0,0,1,.743.039A1.511,1.511,0,0,1,2.928.6a1.119,1.119,0,0,1,.191.921l-.727-.177a.533.533,0,0,0-.1-.423A.736.736,0,0,0,1.862.667a.777.777,0,0,0-.466,0,.345.345,0,0,0-.223.25.319.319,0,0,0,.045.261.745.745,0,0,0,.212.21q.133.09.4.242a4.851,4.851,0,0,1,.577.36,1.2,1.2,0,0,1,.349.412.842.842,0,0,1,.053.587.935.935,0,0,1-.3.5,1.131,1.131,0,0,1-.558.256A1.8,1.8,0,0,1,1.212,3.7a1.821,1.821,0,0,1-.706-.33",
    transform: "translate(54.057 17.012)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.521d3cc05e43210b4375910136677196.svg";
export { ForwardRef as ReactComponent };